export const actionConst = {
    OPEN_ADDRESS_MODAL: 'OPEN_ADDRESS_MODAL',
    CLOSE_ADDRESS_MODAL: 'CLOSE_ADDRESS_MODAL',
    SHOW_ADDRESS_OK: 'SHOW_ADDRESS_OK',
    HIDE_ADDRESS_OK: 'HIDE_ADDRESS_OK',
    OPEN_POSS_WARRANTY_MODAL: 'OPEN_POSS_WARRANTY_MODAL',
    CLOSE_POSS_WARRANTY_MODAL: 'CLOSE_POSS_WARRANTY_MODAL',
};
